module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-forgot-password"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": "Recover password",
      "error": _vm.formError
    }
  }), (!_vm.passwordReset) ? _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginemail"
    }
  }, [_vm._v("Email address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "type": "email",
      "placehoder": "",
      "autocomplete": "username",
      "required": "required"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Recover password")])])])]) : _vm._e(), (_vm.passwordReset) ? _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.loginType === 'account') ? _c('p', [_vm._v("Please check your email inbox and follow the instructions to reset your password.")]) : _c('p', [_vm._v("If you have a Teamwork account you should receive an email from us.\nPlease check your email inbox and follow the instructions to reset your password.")])])]) : _vm._e(), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('router-link', {
    staticClass: "w-button w-button--link",
    attrs: {
      "to": {
        path: _vm.loginLink,
        query: Object.assign(_vm.$route.query, {
          email: _vm.email
        })
      },
      "tag": "button",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Return to login")])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4f03096","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ForgotPassword/ForgotPassword.vue
// module id = 612
// module chunks = 1